import React, { useState, useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import Points from "./Points";
import {
  LogoutOutlined,
  UserOutlined,
} from "@ant-design/icons";

const User = () => {
  const [userDetails, setUserDetails] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        setUserDetails(JSON.parse(storedUser));
      } catch (error) {
        console.error("Error parsing user from localStorage:", error);
      }
    }
  }, []);
  
  return (
      <div className="linkedin-sidebar-left">
          <div className="profile-card">
            <div className="profile-header">
              <div className="profile-cover"></div>
              <div className="profile-avatar">
              <img
                src={
                  userDetails?.profileImage ??
                  "https://img.icons8.com/bubbles/100/000000/user.png"
                }
                referrerPolicy="no-referrer"
                alt="user profile"
              />
              </div>
            </div>
            <div className="profile-info">
              <h3>Hi! {userDetails?.userName ?? "User"}</h3>
             
            </div>

            <div className="profile-invitations">
              <span className="stat-label">Points</span>
              <span className="stat-value"><Points />PSP</span>
            </div>

            <div className="profile-invitation">
              <NavLink to="/personal-details">
               <span className="icon">
          <UserOutlined />
        </span>{" "}
                Personal Details
              </NavLink>
         
              <NavLink to="/sign-out">
              <span className="icon">
          <LogoutOutlined color="red" />{" "}
        </span>
                Sign Out
              </NavLink>
            </div>
          </div>

        
        </div>
  )
}

export default User
